import { AgeRangeAvailableBounds } from "reedy-data/api";
import { Button } from "~/components/button";
import { Icon } from "~/components/icon/icon";
import { Text } from "~/components/text";
import { InfoTooltip } from "~/components/info-tooltip";
import {
  FilterItem as FilterItemProps,
  SearchType,
} from "~/hooks/search/types";
import { ActiveFilterValue } from "./active-filter-value";
import { ActiveFilterClear } from "./active-filter-clear";
import { FilterTypeSelector } from "./filter-type-selector";

interface FilterItemComponentProps extends FilterItemProps {
  isExpanded: boolean;
  onToggle: () => void;
  searchQuery?: string;
  searchType?: SearchType;
  ageRangeAvailableBounds?: AgeRangeAvailableBounds | null;
  ageRangeHasOtherFilters?: boolean;
  ageRangeBoundsLoading?: boolean;
}

export const FilterItem = ({
  icon,
  label,
  type,
  name,
  isExpanded,
  onToggle,
  tooltip,
  searchQuery,
  searchType,
  ageRangeAvailableBounds,
  ageRangeHasOtherFilters,
  ageRangeBoundsLoading,
}: FilterItemComponentProps) => {
  return (
    <div className="border-b border-secondary-200">
      <div className="flex w-full items-center gap-2 px-6 py-3 hover:bg-secondary-25 transition-colors">
        <Button
          variant="link"
          onClick={onToggle}
          className="flex flex-1 items-center gap-2 min-w-0 p-0 text-inherit hover:text-inherit"
        >
          <Icon className="w-5 h-5 shrink-0" name={icon} />
          <Text as="span" variant="label" className="whitespace-nowrap">
            {label}
          </Text>
          {tooltip && (
            <InfoTooltip
              text={tooltip}
              iconSize="small"
              testId={`${name}-info-tooltip`}
            />
          )}
          <ActiveFilterValue filterName={name} />
        </Button>
        <ActiveFilterClear filterName={name} />
        <Button
          variant="link"
          icon="chevron-down"
          onClick={onToggle}
          className="shrink-0 p-0 text-inherit hover:text-inherit"
          iconClassName={`w-4 h-4 transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}
          aria-label={isExpanded ? "collapse" : "expand"}
        />
      </div>
      {isExpanded && (
        <div className="pb-4">
          <FilterTypeSelector
            type={type}
            name={name}
            searchQuery={searchQuery}
            searchType={searchType}
            ageRangeAvailableBounds={ageRangeAvailableBounds}
            ageRangeHasOtherFilters={ageRangeHasOtherFilters}
            ageRangeBoundsLoading={ageRangeBoundsLoading}
          />
        </div>
      )}
    </div>
  );
};
